import { React, lazy, Suspense } from 'react'
import {Paso1, Paso2, Paso3, Cursos, BusquedaAlumCursos, TrasladoCursos} from '../components/index'
const StepAdmin = lazy(()=> import('../../admisiones/AdmisionesStep'))
// current

const StepsLayout = ({ urlSchool, urlCursos, state, send, setModal, headers, IdEmp, respuesta, setLoading, pathname, modal }) => {
  
  // funcion renderizadora, por defecto renderiza el primer componente
  const renderContent = () => {
    if (state.matches('Paso1')) {
      if (pathname === '/campus/centro') {
        return (
          <Suspense fallback="null">
            <StepAdmin pasos={state.context.pasos} />
            <Paso1 urlSchool={urlSchool} urlCursos={urlCursos} state={state} send={send} setModal={setModal} headers={headers} IdEmp={IdEmp} setLoading={setLoading}/>
          </Suspense>  
        )
      } else {
        if (pathname === '/campus/pagos_centro') {
          return (
            <Suspense fallback="null">
              <StepAdmin pasos={state.context.pasosPagos} />
              <BusquedaAlumCursos urlCursos={urlCursos} state={state} send={send} setModal={setModal} headers={headers} IdEmp={IdEmp} Traslado={0} setLoading={setLoading}/>
            </Suspense>
        )
        } else {
          return (
            <Suspense fallback="null">
              <StepAdmin pasos={state.context.pasosPagos} />
              <BusquedaAlumCursos urlCursos={urlCursos} state={state} send={send} setModal={setModal} headers={headers} IdEmp={IdEmp} Traslado={1} setLoading={setLoading} />
            </Suspense>
          )
        }
      }
    }
    if (state.matches('BusquedaAlumCursos')) {
      if (pathname === '/campus/centro') {
        return (
          <Suspense fallback="null">
            <StepAdmin pasos={state.context.pasos} />
            <Paso1 urlCursos={urlCursos} state={state} send={send} setModal={setModal} headers={headers} IdEmp={IdEmp} setLoading={setLoading}/>
          </Suspense>
        )
      } else {
        if (pathname === '/campus/pagos_centro') {
          return (
            <Suspense fallback="null">
              <StepAdmin pasos={state.context.pasosPagos} />
              <BusquedaAlumCursos urlCursos={urlCursos} state={state} send={send} setModal={setModal} headers={headers} IdEmp={IdEmp} Traslado={0} setLoading={setLoading}/>
            </Suspense>
          )
          
        } else {
          return (
            <Suspense fallback="null">
              <StepAdmin pasos={state.context.pasosPagos} />
              <BusquedaAlumCursos urlCursos={urlCursos} state={state} send={send} setModal={setModal} headers={headers} IdEmp={IdEmp} Traslado={1} setLoading={setLoading}/>
            </Suspense>
          )
        }
      }
    }
    if (state.matches('Paso2')) {
      return (
        <Suspense fallback="null">
          <StepAdmin pasos={(pathname === '/campus/centro') ? state.context.pasos : state.context.pasosPagos} />
          <Paso2 IdEmp={IdEmp} urlCursos={urlCursos} state={state} send={send} setModal={setModal} headers={headers} respuesta={respuesta} setLoading={setLoading} pathname={pathname} />
        </Suspense>
      )
    }
    if (state.matches('TrasladoCursos')) {
      return (
        <Suspense fallback="null">
          <StepAdmin pasos={(pathname === '/campus/centro') ? state.context.pasos : state.context.pasosPagos} />
          <TrasladoCursos IdEmp={IdEmp} urlCursos={urlCursos} state={state} send={send} setModal={setModal} headers={headers} respuesta={respuesta} setLoading={setLoading} pathname={pathname} />
        </Suspense>
      )
    }
    if (state.matches('Paso3')) {
      return (
        <Suspense fallback={"null"}>
          <StepAdmin pasos={(pathname === '/campus/centro') ? state.context.pasos : state.context.pasosPagos} />
          <Paso3 urlCursos={urlCursos} state={state} send={send} setModal={setModal} headers={headers} setLoading={setLoading} pathname={pathname} IdEmp={IdEmp} urlSchool={urlSchool}/>
        </Suspense>
      )
    }

    if (state.matches('Cursos')) {
      return (
        <Suspense fallback="null">
          <StepAdmin pasos={(pathname === '/campus/centro') ? state.context.pasos : state.context.pasosPagos} />
          <Cursos urlCursos={urlCursos} state={state} send={send} setModal={setModal} headers={headers} />
        </Suspense>
      )
    }
  }

  return (
    <div>
      {renderContent()}
    </div>
  )
}

export default StepsLayout